import(/* webpackMode: "eager" */ "/codebuild/output/src3924123758/src/mini-apps/node_modules/next/dist/client/link.js");
